import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Mail } from "lucide-react";
import { api, BACKEND, errMsg } from "@/lib/api";
import { AudioPlayer, LyricsDisplay, ExplanationNote } from "@/components/site/Audio";

export default function GiftPage() {
  const { token } = useParams();
  const [gift, setGift] = useState(null);
  const [err, setErr] = useState("");
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get(`/gift/${token}`).then((r) => setGift(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);

  if (err) return <main className="mx-auto max-w-xl px-5 py-28 text-center" data-testid="gift-error"><p className="font-display text-3xl">This gift isn't available</p><p className="mt-3 text-[var(--plum-2)]">{err}</p></main>;
  if (!gift) return <div className="min-h-[70vh]" role="status" aria-label="Loading" />;
  const lang = gift.song_language;

  return (
    <main className="grain relative mx-auto max-w-3xl px-5 py-20 sm:px-8" data-testid="gift-page">
      {!open ? (
        <div className="rounded-3xl border-2 border-dashed border-[var(--gold)]/70 bg-[var(--ivory-surface)] p-10 text-center shadow-xl sm:p-16">
          <Mail className="mx-auto h-10 w-10 text-[var(--rose)]" aria-hidden />
          <p className="eyebrow mt-6">{gift.occasion_label}</p>
          <h1 className="font-display mt-3 text-4xl sm:text-5xl">{gift.solemn ? `In honor of ${gift.recipient_name}` : `For ${gift.recipient_name}`}</h1>
          {gift.sender_name && <p className="mt-3 text-[var(--plum-2)]">From {gift.sender_name}</p>}
          <button className="btn-gold mt-10" onClick={() => setOpen(true)} data-testid="gift-reveal-open-envelope-button">{gift.solemn ? "Open" : "Open your song"}</button>
        </div>
      ) : (
        <div className="rise space-y-8">
          <div className="text-center">
            <p className="eyebrow">{gift.occasion_label}</p>
            <h1 className="font-display mt-3 text-4xl sm:text-5xl" lang={lang.code} dir={lang.rtl ? "rtl" : "ltr"} data-testid="gift-song-title">{gift.title}</h1>
            {gift.dedication && <p className="font-display mx-auto mt-6 max-w-xl text-xl italic text-[var(--plum-2)]" dir="auto" data-testid="gift-dedication">“{gift.dedication}”</p>}
          </div>
          <AudioPlayer src={`${BACKEND}${gift.audio_path}`} title={gift.title} subtitle={`For ${gift.recipient_name}`} devSample={gift.dev_sample} testid="gift-reveal-audio-player" />
          {gift.lyrics && <article className="card-white p-8"><LyricsDisplay text={gift.lyrics} language={lang} testid="gift-lyrics" /></article>}
          {gift.lyrics && <ExplanationNote endpoint={`/gift/${token}/explain`} version={gift.lyrics_version} language={lang} initial={gift.explanation} />}
          <p className="text-center text-xs text-[var(--plum-muted)]">A personalized song created with AI from memories shared by someone who cares about you.</p>
        </div>
      )}
    </main>
  );
}
